import React from "react";
import { HiChevronLeft, HiChevronRight, HiChevronUp, HiChevronDown } from "react-icons/hi";
import { HiChevronLeft as HiChevronLeft2, HiChevronRight as HiChevronRight2 } from "react-icons/hi2";
import CircleButton from "core/Components/Buttons/CircleButton";
import { NOOP } from "core/constants";

type Props = {
    type: 'left' | 'right' | 'up' | 'down' | 'prev' | 'next',
    onClick?: (e: React.MouseEvent) => void,
    size?: number,
    roundColour?: string,
    roundHoverColour?: string,
    chevronColour?: string,
    className?: string,
    linkURL?: string,
    useThinnerChevron?: boolean,
};

const RoundChevronButton: React.FC<Props> = ({
    type,
    onClick = NOOP,
    size = 30,
    roundColour = '',
    roundHoverColour = '',
    chevronColour = '',
    className = '',
    linkURL= '',
    useThinnerChevron = false,
}) => {
    return (
        <CircleButton
            size={size}
            onClick={onClick}
            roundColour={roundColour}
            roundHoverColour={roundHoverColour}
            svgColour={chevronColour}
            className={className}
            linkURL={linkURL}
        >

            {(type === 'left' || type === 'prev') && (
                useThinnerChevron ? <HiChevronLeft2 /> : <HiChevronLeft />
            )}

            {(type === 'right' || type === 'next') && (
                useThinnerChevron ? <HiChevronRight2 /> : <HiChevronRight />
            )}

            {type === 'up' && (
                <HiChevronUp />
            )}

            {type === 'down' && (
                <HiChevronDown />
            )}

        </CircleButton>
    );
};

export default RoundChevronButton;
